import React from 'react';

import { ColorSchema, FontSize } from '../../../typings/design-tokens';
import { IComponent } from '../../../typings/generic-component';
import { SkeletonArrayValues } from '../../../typings/skeleton';
import { makeClassNames } from '../../../utils/styles';
import { setSkeletonArrayOrValue } from '../skeleton-wrapper/skeleton-utils';

import './skeleton.scss';

export interface ISkeleton extends IComponent {
  readonly width?: string | SkeletonArrayValues;
  readonly height?: string | SkeletonArrayValues;
  readonly isText?: boolean;
  readonly fontSize?: FontSize;
  readonly spaceBottom?: string | SkeletonArrayValues;
  readonly className?: string;
}

const classNames = (isText: boolean, colorSchema: ColorSchema, fontSize?: FontSize) =>
  makeClassNames({
    Skeleton: 'skeleton',
    SkeletonItem: ['skeleton__item', isText && fontSize && `skeleton__item-${fontSize}`],
    SkeletonWidth: 'skeleton__item--width',
    SkeletonHeight: !isText && 'skeleton__item--height',
    SkeletonSpaceBottom: 'skeleton__item--space-bottom',
    SkeletonDark: colorSchema && `skeleton__item--${colorSchema}`,
  });

const Skeleton = ({
  /* istanbul ignore next: default value on mandatory field */ width = '100%',
  height,
  /* istanbul ignore next: default value on mandatory field */ isText = false,
  fontSize,
  spaceBottom,
  /* istanbul ignore next: default value on mandatory field */ colorSchema = 'light',
  className,
}: ISkeleton) => {
  const cn = classNames(isText, colorSchema, fontSize);
  const skeletonWidth = width ? { ...setSkeletonArrayOrValue('width', width) } : {};
  const skeletonHeight = height ? { ...setSkeletonArrayOrValue('height', height) } : {};
  const skeletonSize = isText ? { ...skeletonWidth } : { ...skeletonWidth, ...skeletonHeight };
  const skeletonSpaceBottom = spaceBottom ? { ...setSkeletonArrayOrValue('marginBottom', spaceBottom) } : {};

  const classNamesList = [
    cn.SkeletonItem,
    cn.SkeletonDark,
    Array.isArray(width) ? cn.SkeletonWidth : '',
    Array.isArray(height) ? cn.SkeletonHeight : '',
    Array.isArray(spaceBottom) ? cn.SkeletonSpaceBottom : '',
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return <div className={classNamesList} style={{ ...skeletonSize, ...skeletonSpaceBottom }} />;
};

export default Skeleton;
